import { LogOut, Menu, X } from "lucide-react";
import { useCallback, useState } from "react";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { twJoin, twMerge } from "tailwind-merge";
import { logout } from "../apis/auth";
import { ReactComponent as FrydaLogo } from "./../assets/logo/Fryda_logo.svg";
import { SidebarItems } from "./SidebarItems";

export function Navbar() {
  const queryClient = useQueryClient();

  const [expanded, setExpanded] = useState(false);

  const handleOnLogout = useCallback(() => {
    logout();

    queryClient.invalidateQueries();
  }, [queryClient]);

  const navigate = useNavigate();

  const handleOnNavigate = useCallback(
    (route: string) => {
      navigate(route);

      setExpanded(false);
    },
    [navigate]
  );

  return (
    <nav
      className={twMerge(
        "h-screen fixed flex items-center flex-col bg-white shadow-md z-10 px-4 pt-7",
        expanded && "px-6 items-start"
      )}
    >
      <div
        className={twMerge(
          "flex w-full items-center justify-center",
          expanded && "justify-between"
        )}
      >
        {expanded && <FrydaLogo />}
        <button onClick={() => setExpanded((curr) => !curr)}>
          {expanded ? <X /> : <Menu />}
        </button>
      </div>
      <ul className="h-full flex justify-center flex-col gap-10">
        {SidebarItems.map((item, index) => (
          <li
            key={index}
            className={twJoin(
              "relative w-fit flex items-center font-medium cursor-pointer group text-gray-400 hover:text-gray-600",
              expanded && " gap-3"
            )}
            onClick={() => handleOnNavigate(item.to)}
          >
            {item.icon}
            {expanded && <span>{item.label}</span>}
          </li>
        ))}
      </ul>
      <div
        className="px-3 flex items-end justify-center mb-4 cursor-pointer"
        onClick={handleOnLogout}
      >
        <LogOut />
        <span
          className={`overflow-hidden transition-all ${
            expanded ? "w-52 ml-3" : "w-0"
          }`}
        >
          Logout
        </span>
        {!expanded && (
          <div
            className={` absolute left-full rounded-md px-2 py-1 ml-6 bg-indigo-100 text-indigo-500 text-sm invisible opacity-20 -translate-x-3 transition-all group-hover:visible group-hover:opacity-100 group-hover:translate-x-0`}
          >
            Logout
          </div>
        )}
      </div>
    </nav>
  );
}
